import { useFela } from 'react-fela';

import { useNestedGroup } from '../../hooks';
import type { Group } from '../../types';
import { GroupMembers } from '../GroupMembers';
import { NestedGroupOverlay } from '../NestedGroupOverlay';
import { container } from './GroupDetail.rules';

export interface GroupDetailProps {
    id: Group['id'];
}

export const GroupDetail = ({ id }: GroupDetailProps) => {
    const { css } = useFela();

    const { openedNestedGroup, openNestedGroup, closeNestedGroup } = useNestedGroup();

    return (
        <>
            <section className={css(container)}>
                <GroupMembers id={id} openNestedGroup={openNestedGroup} />
            </section>
            <NestedGroupOverlay group={openedNestedGroup} handleClose={closeNestedGroup} />
        </>
    );
};
